import React from 'react';

import { makeStyles } from '@gogame/components';
import { PrimaryFiltersProvider } from '@gogame/filters';

import Slider from './Slider';

const useStyles = makeStyles(
  {
    grid: {
      display: 'flex',

      '& > *': {
        padding: 8,
        minWidth: 0,

        '@media (width < 560px)': {
          flex: '0 0 100%',
        },
        '@media (width >= 560px) and (width < 800px)': {
          flex: '0 0 50%',
        },
        '@media (width >= 800px) and (width < 1040px)': {
          flex: '0 0 33.33%',
        },
        '@media (width >= 1040px) and (width < 1280px)': {
          flex: '0 0 25%',
        },
        '@media (width >= 1280px) and (width < 1520px)': {
          flex: '0 0 20%',
        },
        '@media (width >= 1520px) and (width < 1760px)': {
          flex: '0 0 16.66%',
        },
        '@media (width >= 1760px) and (width < 2000px)': {
          flex: '0 0 14.28%',
        },
        '@media (width >= 2000px)': {
          flex: '0 0 12.5%',
        },

        '&:first-child': {
          paddingLeft: 0,
        },

        '&:last-child': {
          paddingRight: 0,
        },
      },
    },
  },
  { name: 'GgPrimaryFilters' }
);

const PrimaryFilters = ({ primary, children }) => {
  const classes = useStyles();

  return (
    <PrimaryFiltersProvider defaultPrimaryFilters={primary}>
      <Slider
        ContentProps={{
          'data-cy': 'primaryFilters',
          className: classes.grid,
        }}
      >
        {children}
      </Slider>
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
